module.exports = "//__CDN_HOST__/2.0.8/img/auto-lease-calculator-banner.f0332a60.png";